import '.a{display:flex;}.ssr-plugin'
import '.n{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.ax{gap:0.5rem;}.ssr-plugin'
import '.b3{cursor:pointer;}.ssr-plugin'
import '.gh{padding:0.75rem;}.ssr-plugin'
import '.ar{border-radius:1.25rem;}.ssr-plugin'
import '.ay{border:var(--blue-border);}.ssr-plugin'
import '.as{background-color:var(--shades-white);}.ssr-plugin'
import '.cg{transition:background-color 0.2s ease;}.ssr-plugin'
import '.do{width:2.5rem;}.ssr-plugin'
import '.dp{height:2.5rem;}.ssr-plugin'
import '.gi{color:var(--shades-blue-700);}.ssr-plugin'
import '.gj{font-size:0.9rem;}.ssr-plugin'
import '.af{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="a n b c ax b3 gh ar ay as cg"
        style={{
          '&:hover': {
            backgroundColor: 'var(--shades-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="do dp a c n gi"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="gj gi af"
        >
          {label}
        </span>
      </styled.button>
    )
}